import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Avatar } from "@faire/web--source/slate/Avatar";
import { TrophyIcon } from "@faire/web--source/slate/icons/Trophy";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import React from "react";
import styled, { css } from "styled-components";
export var ResultDropdownImageIconItem = function(param) {
    var suggestion = param.suggestion, selected = param.selected, onClick = param.onClick, onHover = param.onHover, onMouseLeave = param.onMouseLeave;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _suggestion_searchData = suggestion.searchData, name = _suggestion_searchData.name, is_top_shop = _suggestion_searchData.is_top_shop, profile_image = _suggestion_searchData.profile_image;
    return /*#__PURE__*/ _jsx("li", {
        children: /*#__PURE__*/ _jsxs(Wrapper, {
            to: suggestion.url,
            onClick: function() {
                return onClick(suggestion);
            },
            onMouseEnter: onHover,
            onMouseLeave: onMouseLeave,
            $selected: selected,
            children: [
                /*#__PURE__*/ _jsx(Spacer, {
                    width: {
                        mobileAndAbove: "2x",
                        tabletAndAbove: 4
                    }
                }),
                /*#__PURE__*/ _jsxs(Column, {
                    children: [
                        /*#__PURE__*/ _jsx(Spacer, {
                            height: "1x"
                        }),
                        /*#__PURE__*/ _jsx(StyledAvatar, {
                            size: "smaller",
                            altTag: strictLocalize({
                                id: "/Kxbee",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Brand logo image"
                                    }
                                ]
                            }),
                            $isTopShop: is_top_shop,
                            iconData: is_top_shop ? {
                                position: "bottomRight",
                                icon: /*#__PURE__*/ _jsx(TrophyIcon, {
                                    color: Decorative.icon.green,
                                    fill: Decorative.icon.green,
                                    width: "15",
                                    height: "15",
                                    active: true
                                })
                            } : undefined,
                            image: profile_image
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            height: "1x"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    width: {
                        mobileAndAbove: "2x",
                        tabletAndAbove: "1x"
                    }
                }),
                /*#__PURE__*/ _jsx(MaxWidthLabel, {
                    children: name
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    width: "2x"
                })
            ]
        })
    });
};
var StyledAvatar = styled(Avatar).withConfig({
    componentId: "sc-a0463aa0-0"
})([
    "",
    ""
], function(param) {
    var $isTopShop = param.$isTopShop;
    return $isTopShop ? css([
        "border:2px solid ",
        ";border-radius:50%;"
    ], Decorative.icon.green) : "";
});
var Wrapper = styled(Link).withConfig({
    componentId: "sc-a0463aa0-1"
})([
    "display:flex;align-items:center;cursor:pointer;background-color:",
    ";",
    "{border-radius:",
    ";}"
], function(param) {
    var $selected = param.$selected;
    return $selected ? Core.surface.subdued : null;
}, responsiveMediaQueries.tabletAndAbove, getSpacing("5x"));
var MaxWidthLabel = styled(Typography).withConfig({
    componentId: "sc-a0463aa0-2"
})([
    "max-width:",
    ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
], getSpacing(207));
